export const HEADS = [
  { name: 'なし', value: 0 },
  { name: 'てつかぶと', value: 6 },
  { name: 'ふしぎなぼうし', value: 8 },
  { name: 'ロトのかぶと', value: 20 }
]
